import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Button } from "react-md";
import { Card, CardTitle, CardText } from "react-md/lib/Cards";
import { getIsIntegrated } from "requests/dwellingBlocks";
import Message from "components/Homeowner/CaseForms/Actions/OnHold/DwellingBlocks/Message";
import { DWELLING_BLOCKS_MESSAGE_ADD } from "typeConstants/rights";

export const DWELLING_BLOCKS_MESSAGE_TAB_ID = "DWELLING_BLOCKS_MESSAGE_TAB_ID";
export const DWELLING_BLOCKS_CHECKBOX_TAB_ID = "DWELLING_BLOCKS_CHECKBOX_TAB_ID";

const DwellingBlocks = ({
  caseHeader,
  canSendMessage,
  openCaseActionTab,
  closeTab,
}) => {
  const [isIntegrated, setIsIntegrated] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const mounted = useRef(true);

  useEffect(() => {
    getIsIntegrated(caseHeader.policyInfo.customerInfo.customerNumber, getDwellingBlocksDetails, mounted);
    return () => {
      mounted.current = false;
    };
  }, []);

  const getDwellingBlocksDetails = (response) => {
    if (response) {
      setIsIntegrated(response);
      setExpanded(true);
    }
  };

  const handleMessageClick = () => {
    openCaseActionTab(
      <Message onSuccessCallback={onMessageCallback} canSendMessage={canSendMessage}  />,
      "Message Request",
      DWELLING_BLOCKS_MESSAGE_TAB_ID
    );
  };

  const onMessageCallback = () => {
    closeTab(DWELLING_BLOCKS_MESSAGE_TAB_ID);
  };

  const toggleExpanded = () => setExpanded(!expanded);

  if (!isIntegrated) {
    return null;
  }

  return (
    <Card
      className="md-cell md-cell--12 case-header"
      expanded={expanded}
      onExpanderClick={toggleExpanded}
    >
      <CardTitle
        title="Dwelling Blocks Actions"
        onClick={toggleExpanded}
        expander
      />
      <CardText expandable>
        <span className={"case-action"}>
          <Button
            id="message-action-button"
            raised
            primary
            onClick={handleMessageClick}
            disabled={!canSendMessage}
          >
            Send Message
          </Button>
        </span>
      </CardText>
    </Card>
  );
};

DwellingBlocks.propTypes = {
  controlNumber: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),
  caseHeader: PropTypes.object,
  canSendMessage: PropTypes.bool,
  openCaseActionTab: PropTypes.func,
  closeTab: PropTypes.func
};

const mapStateToProps = (state) => {
  return {
    controlNumber: state.caseDetails.controlNumber,
    caseHeader: state.caseForms.caseHeader,
    canSendMessage: state.user.profile.rights.includes(DWELLING_BLOCKS_MESSAGE_ADD),
  };
};

export default connect(mapStateToProps)(DwellingBlocks);